import find from 'lodash/find';

export class SuggestModalCacheService {
  _cache = [];

  /**
   * @methodOf SuggestModalCache
   * @name getCached
   * @param {String} key
   * @param {Object} firstItem
   * @param {Number} matchesCount
   * @returns {Object}
   * @description try to get previousely retrieved items from cache
   */
  getCached = (key, firstItem, matchesCount) => {
    const cached = find(this._cache, { key });

    if (!cached || !cached.sub) {
      return;
    }

    const items = cached.sub.slice(firstItem, firstItem + matchesCount);
    const error = items.length < matchesCount || items.includes(undefined);

    if (error) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return {
      subCount: cached.subCount,
      sub: items,
    };
  };

  /**
   * @methodOf SuggestModalCache
   * @name saveCached
   * @param {String} key
   * @param {Object} firstItem
   * @param {Array} items
   * @param {Number} total
   * @description stores or updates items in cache
   */
  saveCached = (key, firstItem, items, total) => {
    const cached = find(this._cache, { key });

    if (!cached) {
      const shiftedItems = [];

      items.forEach((item, i) => {
        shiftedItems[firstItem + i] = item;
      });

      this._cache.push({
        key,
        subCount: total,
        sub: shiftedItems,
      });
      return;
    }

    cached.subCount = total;
    items.forEach((item, i) => {
      cached.sub[firstItem + i] = item;
    });
  };
}

const SuggestModalCache = new SuggestModalCacheService();

export default SuggestModalCache;
